import AES from 'crypto-js/aes';
import {type FamlyticsEvent} from '@famly/stat_ts-utils_famlytics';

export const encrypt = (event: FamlyticsEvent, key: string) => {
    return AES.encrypt(JSON.stringify(event), key).toString();
};
